import getUserConfirmation from "./getUserConfirmation";

export default getUserConfirmation;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/ConfirmNavigate/index.ts